module.exports = __webpack_public_path__ + "static/media/04.039fc64d.png";